var XPortal = XPortal || {};
XPortal.ActivityLoger = (function () {

    VisitedActivity = function () {
        var postData = {
            model: { PageType: "Visited page" }
        };
        PostActivityLog(postData);
    };

    TrackLinkActivity = function (href, activityType) {
        var postData = {
            model: { PageType: activityType, Url: href }
        };
        PostActivityLog(postData);
    };

    TrackExport = function (activityType) {
        var postData = {
            model: { PageType: activityType }
        };
        PostActivityLog(postData);
    };

    PostActivityLog = function (postData) {
        if (XPortal.ActivityLoger.disable) return;
        $.ajax({
            url: XPortal.Utils.EnsureInProfile("/umbraco/surface/member/MemberActivity"),
            type: 'POST',
            dataType: 'json', contentType: 'application/json; charset=utf-8',
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: JSON.stringify(postData),
        });
    };

    return {
        disable: false,
        VisitedActivity: VisitedActivity,
        TrackLinkActivity: TrackLinkActivity,
        TrackExport: TrackExport
    };
}());
